import React from "react";
import classNames from "classnames";
import { TextAreaConfig } from "../types.d";
import Variant from "shared/enums/Variant";
import Size from "shared/enums/Size";
import { DEFAULT_TEXTAREA_NO_OF_ROWS, MAX_DEFAULT_TEXTAREA_LENGTH } from "shared/utils/constants";
import FieldValueCount from "shared/components/fieldValueCount";

function TextArea({
  rows = DEFAULT_TEXTAREA_NO_OF_ROWS,
  withCount = true,
  maxCount = MAX_DEFAULT_TEXTAREA_LENGTH,
  ...props
}: TextAreaConfig) {
  const computedClassNames = React.useMemo(() => {
    return getClassNames(props.className, props.variant, props.size, props.hasError);
  }, [props.className, props.hasError, props.size, props.variant]);

  return (
    <div className={computedClassNames}>
      <textarea
        data-testid={props.name}
        name={props.name}
        value={props.value}
        onBlur={props.onBlur}
        onChange={props.onChange}
        id={props.name}
        disabled={props.disabled}
        placeholder={props.placeholder}
        rows={rows}
        autoFocus={props.autoFocus}
      />
      {withCount && <FieldValueCount maxCount={maxCount} value={props.value} showCharacterCount />}
    </div>
  );
}

export default TextArea;

function getClassNames(className?: string, variant?: Variant, size?: Size, hasError?: boolean | string) {
  const computedClassNames = classNames(className, {
    textBox: true,
    [`textBox--${variant}`]: variant,
    [`textBox--${size}`]: size,
    [`textBox--hasError`]: hasError
  });
  return computedClassNames;
}
